import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { getCustomerShippingMethod } from "./fulfillment-group-csv-utils";

export const CustomerShippingSelectionCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Customer shipping",
    cell: (row) => {
      return getCustomerShippingMethod(row);
    },
  };
